import React, { useState } from "react";
import { db } from "../services/firebase";
import {
  collection,
  query,
  where,
  getDoc,
  doc,
  getDocs,
} from "firebase/firestore";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import bcrypt from "bcryptjs";
import { useSeller } from "../contexts/SellerContext";
import { saveData } from "../utils/storage";
import Logo from "../JMIlogo.png";

const Login = () => {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { updateSeller } = useSeller();

  // Handle login with mobile + password
  const handleLogin = async () => {
    if (mobile.length !== 10) {
      alert("Enter a valid 10-digit mobile number");
      return;
    }

    if (!password) {
      alert("Enter your password");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // Get seller data by mobile
      const q = query(collection(db, "sellers"), where("mobile", "==", mobile));
      const snap = await getDocs(q);

      if (snap.empty) {
        alert("Seller not found");
        setLoading(false);
        return;
      }

      const sellerDoc = snap.docs[0];
      const data = sellerDoc.data();

      // Verify password
      const isMatch = await bcrypt.compare(password, data.passwordHash);
      if (!isMatch) {
        alert("Incorrect password");
        setLoading(false);
        return;
      }
      const sellerId = data.sellerId || data.buyerId || sellerDoc.id;
      // Fetch registration data
      const sellerRegistrationDoc = doc(db, "sellerregistrations", sellerId);
      const sellerRegistrationSnap = await getDoc(sellerRegistrationDoc);
      const sellerRegistrationData = sellerRegistrationSnap.exists()
        ? sellerRegistrationSnap.data()
        : {};
      
      const state=sellerRegistrationData.contactState;
      const district=sellerRegistrationData.contactDistrict;
      // Fetch profile for redirect logic
      const sellerProfileRef = doc(db, "profile", sellerId);
      const profileSnap = await getDoc(sellerProfileRef);
      const profileData = profileSnap.exists() ? profileSnap.data() : {};

      // Prepare seller data
      const sellerData = {
        sellerId,
        mobile,
        organizationName: sellerRegistrationData.organizationName || "",
        segment: profileData.segment,
        logourl: profileData.storeLogoUrl,
        state,
        district,
        registrationStatus: profileData.registrationStatus,
        sellerRegistration: profileData.SellerRegistration,
        segmentRegistration: profileData.SegmentRegistration,
        productRegistration: profileData.ProductRegistration || false,
        lastUpdated: Date.now(),
      };

      // Persist to storage (for auto-login after app kill)
      await saveData("sellerData", sellerData);
      // Update context
      updateSeller({
        sellerId: sellerId,
        mobile,
        organizationName: sellerRegistrationData.organizationName || "",
        logourl: profileData.storeLogoUrl,
        segment: profileData.segment,
        state,
        district,
        registrationStatus: false,
        sellerRegistration: profileData.SellerRegistration,
        segmentRegistration: profileData.SegmentRegistration,
        productRegistration: profileData.ProductRegistration || false,
      });

      // Redirect based on registration progress
      if (!profileData.SellerRegistration) {
        nav("/sellerregistration");
      } else if (!profileData.SegmentRegistration) {
        nav("/segmentregistration");
      } else if (!profileData.ProductRegistration) {
        nav("/productregistration");
      } else {
        nav("/dashboard");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(err.message || "Login failed");
      alert(`Login failed: ${err.message || err}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <h1 className="title">
        <img src={Logo} className="logo" alt="logo" />
      </h1>
      <p className="subtitle">Seller Desk</p>

      <div className="login-box">
        <h2>Seller Login</h2>

        <label>Mobile Number</label>
        <input
          type="tel"
          maxLength="10"
          placeholder="Enter Mobile Number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
        />

        <label>Password</label>
        <input
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button className="login-btn" onClick={handleLogin} disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>

        <p className="forgot" onClick={() => nav("/forgetpassword")}>
          Forgot Password?
        </p>
      </div>

      {error && <p className="error">{error}</p>}

      <p className="register-link">
        Don't have an account?{" "}
        <span onClick={() => (window.location.href = "/register")}>
          Register now
        </span>
      </p>

      <p className="support">
        <img src="/whatsapp.svg" alt="whatsapp" className="whatsapp-icon" />
        <span
          onClick={() => window.open("https://wa.me/919053999090", "_blank")}
        >
          {" "}
          Need help?{" "}
        </span>
        Contact Seller Support
      </p>
    </div>
  );
};

export default Login;
